export default __webpack_public_path__ + "static/css-9d0dad0feff2b8527c5c0911ec1fca61.png";